import { render } from "./private-agreement.vue?vue&type=template&id=78f72f2a&scoped=true"
const script = {}

import "./private-agreement.vue?vue&type=style&index=0&id=78f72f2a&scoped=true&lang=css"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f72f2a"]])

export default __exports__